<script lang="ts" setup>
const { active = true } = defineProps<{
  active?: boolean
}>()
</script>

<template>
  <!-- @formatter:off -->
  <slot /><span
    v-if="active"
    class="text-alert-enabled"
    >*
  </span>
  <!-- @formatter:on -->
</template>